import { useState, useCallback } from 'react';
import api from '../services/api';

/**
 * Hook for creating announcements remotely in the Empresas manager.
 */
export function useAnnouncements() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const create = useCallback(async (announcementData) => {
    try {
      setLoading(true);
      setError(null);
      if (announcementData instanceof FormData) {
        const entries = [];
        for (const entry of announcementData.entries()) {
          entries.push([entry[0], entry[1]]);
        }
        console.log('useAnnouncements.create FormData entries', entries);
      } else {
        console.log('useAnnouncements.create payload', announcementData);
      }
      const { data } = await api.post('/announcements', announcementData);
      console.log('useAnnouncements.create response', data);
      return data;
    } catch (err) {
      console.error('useAnnouncements.create error', err);
      const message = err.response?.data?.message || err.message;
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  }, []);

  const list = useCallback(async (companyId = null) => {
    try {
      setLoading(true);
      setError(null);
      const params = companyId ? `?companyId=${companyId}` : '';
      const { data } = await api.get(`/announcements${params}`);
      return data.data || [];
    } catch (err) {
      console.error('useAnnouncements.list error', err);
      const message = err.response?.data?.message || err.message;
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteAnnouncement = useCallback(async (id, databaseId) => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await api.delete(`/announcements/${id}`, {
        data: { databaseId },
      });
      return data;
    } catch (err) {
      console.error('useAnnouncements.delete error', err);
      const message = err.response?.data?.message || err.message;
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    create,
    list,
    deleteAnnouncement,
  };
}
